module.exports = __webpack_public_path__ + "static/media/CTA1.59676c0c.avif";